import React from "react";
import { Box, Modal, Stack } from "@mui/material";
const LoginWarningModal = ({ openModal, handleCloseModal }) => {

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          border: "1px solid #D1D9E0",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 30px)",
          maxWidth: "790px",
          backgroundColor: "#fff",
          maxHeight: "calc(100% - 30px)",
          overflow: "auto",
          borderRadius: "10px",
        }}
        className="newpopup"
      >
        <Stack className=" updatelicense" p={2}>
          <span
            onClick={() => handleCloseModal()}
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="2.70703"
                width="1"
                height="28"
                rx="0.5"
                transform="rotate(-45 2 2.70703)"
                fill="#303030"
              />
              <rect
                x="21.7988"
                y="2"
                width="1"
                height="28"
                rx="0.5"
                transform="rotate(45 21.7988 2)"
                fill="#303030"
              />
            </svg>
          </span>
          <Stack
            sx={{ padding: "16px 20px", paddingTop: "20px" }}
            alignItems={"center"}
          >
            <h2 style={{ textAlign: "center" }}>
              {" "}
              Your need to Login or Signup to continue your journey further{" "}
            </h2>
          </Stack>
          <Stack>
            <img
              src="/images/login.svg"
              style={{ width: "100%", maxWidth: "350px", margin: "0 auto" }}
              alt="login"
            />
          </Stack>

          <Stack
            className="updatelicense_btn"
            flexDirection={"row"}
            justifyContent={"flex-end"}
            gap={1}
            sx={{ padding: "16px 20px" }}
          >
            <button
              className="outline_btn"
              style={{
                width: "100%",
                padding: "10px 15px",
              }}
            >
              <a
                href={`${process.env.REACT_APP_SIGNIN_URL}?redirect=${window.location.href}`}
                target="_blank"
                style={{
                  width: "100%",
                  display: "block",
                }} rel="noreferrer"
              >
                Singup
              </a>
            </button>
            <button
              className="blue_btn"
              style={{
                width: "100%",
                padding: "10px 15px",
              }}
            >
              <a
                href={`${process.env.REACT_APP_SIGNIN_URL}?redirect=${window.location.href}`}
                target="_blank"
                style={{
                  width: "100%",
                  display: "block",
                }} rel="noreferrer"
              >
                Login
              </a>
            </button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default LoginWarningModal;
